// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("rescript/lib/js/curry.js");
var Media = require("../../common/Media/Media.bs.js");
var Utils = require("../../../utils/Utils.bs.js");
var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Theme__Color = require("../../common/Theme/Theme__Color.bs.js");
var Theme__Color__Vars = require("../../common/Theme/Theme__Color__Vars.bs.js");

var baseStyle = CssJs.style([
      CssJs.borderWidth({
            NAME: "px",
            VAL: 1
          }),
      CssJs.borderStyle("solid"),
      CssJs.backgroundColor(Theme__Color.white),
      CssJs.width({
            NAME: "percent",
            VAL: 100
          }),
      CssJs.padding2({
            NAME: "px",
            VAL: 6
          }, {
            NAME: "px",
            VAL: 6
          }),
      CssJs.lineHeight({
            NAME: "abs",
            VAL: 1.25
          }),
      CssJs.borderColor(Theme__Color.alto),
      CssJs.transition(150, undefined, undefined, "border-color"),
      CssJs.resize("none"),
      CssJs.hover([CssJs.cursor("text")])
    ]);

var baseBorderStyle = CssJs.style([CssJs.hover([CssJs.borderColor(Theme__Color.silver)])]);

var isFocusedBorderStyle = CssJs.style([CssJs.borderColor(Theme__Color.goldTips)]);

var baseInnerTextAreaStyle = CssJs.style([
      CssJs.width({
            NAME: "percent",
            VAL: 100
          }),
      CssJs.borderWidth({
            NAME: "px",
            VAL: 1
          }),
      CssJs.borderStyle("solid"),
      CssJs.borderColor("transparent"),
      CssJs.resize("none"),
      Media.maxWidthJs("md")([CssJs.fontSize({
                  NAME: "px",
                  VAL: 16
                })]),
      CssJs.backgroundColor(Theme__Color__Vars.white),
      CssJs.padding({
            NAME: "px",
            VAL: 2
          }),
      CssJs.color(Theme__Color__Vars.black)
    ]);

function innerTextAreaStyle(maxHeight_, param) {
  return CssJs.merge([
              baseInnerTextAreaStyle,
              Belt_Option.mapWithDefault(maxHeight_, CssJs.style([]), (function (maxHeight_) {
                      return CssJs.style([
                                  CssJs.maxHeight(maxHeight_),
                                  CssJs.overflowY("auto")
                                ]);
                    }))
            ]);
}

var Styles = {
  baseStyle: baseStyle,
  baseBorderStyle: baseBorderStyle,
  isFocusedBorderStyle: isFocusedBorderStyle,
  baseInnerTextAreaStyle: baseInnerTextAreaStyle,
  innerTextAreaStyle: innerTextAreaStyle
};

function ConversationMessageArea(props) {
  var buttons = props.buttons;
  var attachments = props.attachments;
  var textInputDisabled = props.textInputDisabled;
  var onChangeTextProp = props.onChangeText;
  var isFocused = props.isFocused;
  var isFocused$1 = isFocused !== undefined ? isFocused : false;
  var onChangeTextProp$1 = onChangeTextProp !== undefined ? onChangeTextProp : (function (prim) {
        
      });
  var textInputDisabled$1 = textInputDisabled !== undefined ? textInputDisabled : false;
  var attachments$1 = attachments !== undefined ? Caml_option.valFromOption(attachments) : null;
  var buttons$1 = buttons !== undefined ? Caml_option.valFromOption(buttons) : null;
  var fallbackRef = React.useRef(null);
  var inputRef = Belt_Option.getWithDefault(props.inputRef, fallbackRef);
  return React.createElement("div", {
              className: CssJs.merge([
                    baseStyle,
                    isFocused$1 ? isFocusedBorderStyle : baseBorderStyle
                  ]),
              id: "conversation-message-area",
              onClick: (function (evt) {
                  var eventTarget = evt.target;
                  var match = inputRef.current;
                  var match$1 = eventTarget.nodeName !== "BUTTON";
                  if (!(match == null) && match$1 && !isFocused$1) {
                    return match.focus();
                  }
                  
                })
            }, React.createElement("textarea", {
                  ref: Caml_option.some(function (i) {
                        Utils.React.setCurrentRef(inputRef, i);
                      }),
                  className: innerTextAreaStyle(props.maxHeight, undefined),
                  disabled: textInputDisabled$1,
                  placeholder: props.placeholder,
                  value: Belt_Option.getWithDefault(props.text, ""),
                  onKeyDown: props.onKeyDown,
                  onFocus: props.onFocus,
                  onBlur: props.onBlur,
                  onChange: (function (evt) {
                      var e = evt.target.value;
                      var element = inputRef.current;
                      if (!(element == null)) {
                        element.setAttribute("style", "height:auto");
                        var height = element.scrollHeight + 2 | 0;
                        element.setAttribute("style", "height:" + (String(height) + "px"));
                      }
                      Curry._1(onChangeTextProp$1, e);
                    })
                }), attachments$1, buttons$1);
}

var make = ConversationMessageArea;

exports.Styles = Styles;
exports.make = make;
/* baseStyle Not a pure module */
